<template>
    <div class="testimonial-area-1 section-gap-equal">
        <div class="container">
            <div class="row g-lg-5">
                <div class="col-lg-5">
                    <div class="testimonial-heading-area">
                        <div class="section-title section-left" data-aos-delay="50" data-aos="fade-up" data-aos-duration="800">
                            <span class="pre-title">香港基督徒中樂團</span>
                            <h2 class="title">樂團簡介</h2>
                            <span class="shape-line"><i class="icon-19"></i></span>
                            <p>
                                香港基督徒中樂團 (簡稱「基中」)乃跨宗派的非牟利基督徒組織，宗旨在於以中國器樂讚美上帝及服侍教會。
                            </p>
                            <p>
                                「基中」現有會員約40人，當中包括前香港演藝學院的高級講師，神學院教授，專業音樂家，及業餘中樂愛好者。
                            </p>
                            <p>
                                樂團現有三位資深顧問：前台南神學院院⾧、民俗音樂學專家駱維道博士、香港中文大學文學院院⾧羅炳良教授及前香港演藝學院高級講師方錦源先生。
                            </p>
                            <p>
                                團牧為前任聖經公會總幹事李志剛牧師。
                            </p>
                            <!-- <n-link to="#" class="edu-btn btn-large">View All<i class="icon-4"></i></n-link> -->
                            <!-- View All<i class="icon-4"></i> -->
                        </div>
                    </div>
                </div>

                <div class="col-lg-7">
                    <swiper class="home-one-testimonial-activator swiper" :options="swiperOptions">

                        <div class="swiper-slide">
                            <div class="testimonial-grid">
                                <div>
                                    <!-- <img src="@/static/images/retco/Kanto.png"> -->
                                </div>
                                <br>
                                <div class="content">
                                    <h2 class="title">宗旨</h2>
                                    <p>本會成立的七大宗旨是：</p>
                                    <ul class="features-list" data-aos-delay="150" data-aos="fade-up" data-aos-duration="800">
                                        <li>透過演奏中國樂器，以推動和促進聖樂事工。</li>
                                        <li>為演奏中國樂器的基督徒提供機會，透過樂器事奉上帝。</li>
                                        <li>以中國樂器協助華人基督教會進行敬拜聚會。</li>
                                        <li>為音樂敬拜提供另一種表達方式。</li>
                                        <li>主領或協助福音聚會的音樂部分。</li>
                                        <li>為作曲家提供發展華人基督教音樂的媒介。</li>
                                        <li>舉辦教育活動，以鼓勵更多人透過中國樂器事奉主。</li>
                                    </ul>                                
                                </div>
                            </div>
                        </div>

                        <div class="swiper-slide">
                            <div class="testimonial-grid">
                                <div>
                                    <!--<img src="@/static/images/retco/Kanto.png">-->
                                </div>
                                <br>
                                <div class="content">
                                    <h2 class="title">簡史</h2>
                                    <p>
                                        在一九九六年年初，信義宗神學院的聖樂與禮儀學老師伍中恩女士，為了籌備九七年信義宗大會，委託本會前音樂總監方錦源先生組織一隊中樂團於大會中獻奏。大會在崇拜中用了一個十三人的中樂隊，開創了香港華人基督教聖樂史的先河。
                                    </p>  
                                    <p>
                                        大會後，隊員均有異象組成一個事奉上帝的固定樂團，「基中」就在一九九七年七月十三日誕生了。
                                    </p>
                                    <p>
                                        蒙上帝的恩待，本會得到禮賢會灣仔堂的支持，借出副堂，讓樂團有固定的地方練習。
                                    </p>    
                                    <br>            
                                </div>
                            </div>
                        </div>

                        <div class="swiper-slide">
                            <div class="testimonial-grid">
                                <div>
                                    <!--<img src="@/static/images/retco/Kanto.png">-->
                                </div>
                                <br>
                                <div class="content">
                                    <h2 class="title">團訓</h2>
                                    <p>
                                        你們要讚美耶和華！在神的聖所讚美他！在他顯能力的穹蒼讚美他！
                                    </p>  
                                    <p>
                                        要因他大能的作為讚美他，按著他極美的大德讚美他！
                                    </p>
                                    <p>
                                        要用角聲讚美他，鼓瑟彈琴讚美他！
                                    </p> 
                                    <p>
                                        擊鼓跳舞讚美他！用絲弦的樂器和簫的聲音讚美他！
                                    </p> 
                                    <p>
                                        用大響的鈸讚美他！用高聲的鈸讚美他！
                                    </p> 
                                    <p>
                                        凡有氣息的都要讚美耶和華！你們要讚美耶和華！
                                    </p> 
                                    詩篇 第一百五十篇             
                                </div>
                            </div>
                        </div>

                        <div class="swiper-slide">
                            <div class="testimonial-grid"> 
                                <div>
                                    <!--<img src="@/static/images/retco/Nagano.png" alt="Testimonial">-->
                                </div>
                                <br>
                                <div class="content">
                                    <h2 class="title">事奉範疇</h2>
                                    <ul class="features-list" data-aos-delay="150" data-aos="fade-up" data-aos-duration="800">
                                        <li>協助教會在崇拜中使用中樂敬拜上帝，如獻奏禮儀音樂及伴唱聖詩等；</li>
                                        <li>以中樂協助教會在佈道會或其他形式聚會的聖樂事工；</li>
                                        <li>主辦或與其他基督教組織合辦聖樂分享會；</li>
                                        <li>協助灌錄聖樂等。</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import AOS from 'aos'
    import 'aos/dist/aos.css'

    import { Swiper, SwiperSlide } from "vue-awesome-swiper";
    import 'swiper/css/swiper.css'    

    export default {

        components: {
            Swiper,
            SwiperSlide
        },

        mounted() {
            AOS.init();
        },       

        data () {
            return {
                swiperOptions: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    pagination: false,
                    grabCursor: true,
                    speed: 1500,
                    autoplay: {
                        delay: 9000
                    },
                    breakpoints: {
                        577: {
                            slidesPerView: 2
                        }
                    }
                }
            }
        }
    }
</script>